import React,{Component} from "react";
import { Container, Row, Col} from "shards-react";
import PageTitle from "../common/PageTitle";
import { Redirect } from 'react-router';
import DisplayAttendance from "./DisplayAttendance";
import ClassList from './ClassList';
import AddAttendance from './AddAttendance';
import firebase from '../firebase';

export default class Attendance extends Component{

  constructor(props) {
    super(props);
  
    this.state = {
      add_homework : false,
      selected_class:undefined,
      selected_date:undefined,
      showAddAttendance:false,
      trigger_get_attendance:false,
      logged_in : false,
    };

    this.ShowViewHomeWork = this.ShowViewHomeWork.bind(this);
    this.ShowAddHomeWork  = this.ShowAddHomeWork.bind(this);
    this.set_selected_class = this.set_selected_class.bind(this);
    this.set_selected_date = this.set_selected_date.bind(this);
    this.stop_trigger_get_attendance =this.stop_trigger_get_attendance.bind(this);
    this.trigger_get_attendance = this.trigger_get_attendance.bind(this);
  }

  set_selected_class = (class_name)=>{
      this.setState({selected_class:class_name});
  }

  set_selected_date = (value) =>{
      this.setState({selected_date:value});
  }

  ShowViewHomeWork = () =>{
    this.setState({add_homework:false});
  }

  ShowAddHomeWork = () =>{
    this.setState({add_homework:true});
  }

  trigger_get_attendance=()=>{
      this.setState({trigger_get_attendance:true});
  }

  stop_trigger_get_attendance=()=>{
      this.setState({trigger_get_attendance:false});
  }

   componentWillMount(){
    var that = this;
    var user = firebase.auth().currentUser;

      if (user) {
            // User is signed in.
            this.setState({logged_in:true});
      } else {
          // No user is signed in.
          this.setState({logged_in:false});
      }

  }




 

		render(){

      
    if(this.state.logged_in){
        //do nothing
    }
    else{
      return <Redirect push to="/login" />;
    }

      
			return (
					<Container fluid className="main-content-container px-4">

						 {/* Page Header */}
    					<Row noGutters className="page-header py-4">
      									<PageTitle sm="6" title="Attendance" subtitle="Class" className="text-sm-left" />
    					</Row>

        			 <Row>
                  <Col lg="4">
                        <ClassList set_class={this.set_selected_class}/>
                  </Col>
                  <Col lg="8">
                       <DisplayAttendance selected_class={this.state.selected_class} 
                                          set_selected_date={this.set_selected_date}
                                          add_attendance={()=>{this.setState({showAddAttendance:true})}}
                                          trigger_get = {this.state.trigger_get_attendance}
                                          stop_trigger_get_attendance={this.stop_trigger_get_attendance}
                                          />
                  </Col>
              </Row>


              <AddAttendance show={this.state.showAddAttendance} 
                             handleClose={()=>{this.setState({showAddAttendance:false})}}
                             selected_class={this.state.selected_class}
                             selected_date={this.state.selected_date}
                             trigger_get_attendance={this.trigger_get_attendance}
                            />
              			
					</Container>

			)
		}

}







